export default __webpack_public_path__ + "static/media/video.58a52645.svg";